import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementCollectDocument, OnboardingSessionConfig } from '@onefootprint/request-types';
import { FaceModelProvider } from '@onefootprint/vision';
import { useEffect } from 'react';
import type { DeviceInfo } from '@/idv2/utils/get-device';
import { trackAction } from '@/idv2/utils/logger';
import { ImgProcessorsContextProvider } from '../components/image-processors';
import { MissingPermissionsSheetProvider } from '../components/missing-permissions-sheet';
import { SelfieProvider } from './context/selfie-context';
import Router from './pages/router';
type SelfieProps = {
  authToken: string;
  device: DeviceInfo;
  requirement: OnboardingRequirementCollectDocument;
  onboardingConfig: OnboardingSessionConfig;
  onDone: () => void;
};
const Selfie = t0 => {
  const $ = _c(20);
  const {
    authToken,
    device,
    requirement,
    onboardingConfig,
    onDone
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  const isConsentMissing = requirement.config.kind === "selfie" && requirement.config.shouldCollectConsent;
  const isFaceDetectionEnabled = requirement.config.kind !== "selfie" || requirement.config.requireFaceDetection !== "off";
  const t2 = device.initialCameraPermissionState || "prompt";
  let t3;
  if ($[1] !== authToken || $[2] !== device || $[3] !== isConsentMissing || $[4] !== isFaceDetectionEnabled || $[5] !== onboardingConfig || $[6] !== requirement || $[7] !== t2) {
    t3 = {
      authToken,
      device,
      requirement,
      onboardingConfig,
      isConsentMissing,
      isFaceDetectionEnabled,
      cameraPermissionState: t2
    };
    $[1] = authToken;
    $[2] = device;
    $[3] = isConsentMissing;
    $[4] = isFaceDetectionEnabled;
    $[5] = onboardingConfig;
    $[6] = requirement;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onDone) {
    t4 = <ImgProcessorsContextProvider><Router onDone={onDone} /></ImgProcessorsContextProvider>;
    $[9] = onDone;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isFaceDetectionEnabled || $[12] !== t4) {
    t5 = <FaceModelProvider isSelfieRequired={isFaceDetectionEnabled}>{t4}</FaceModelProvider>;
    $[11] = isFaceDetectionEnabled;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== device || $[15] !== t5) {
    t6 = <MissingPermissionsSheetProvider device={device}>{t5}</MissingPermissionsSheetProvider>;
    $[14] = device;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t6) {
    t7 = <SelfieProvider initialContext={t3}>{t6}</SelfieProvider>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default Selfie;
function _temp() {
  trackAction("selfie:started");
}